import React, { PropsWithChildren } from 'react';
import { Spin } from 'antd';

const LoaderWrapper: React.FC<PropsWithChildren<{ loading: boolean }>> = props => {
  return props.loading ? <Spin size={'large'}>{props.children}</Spin> : <>{props.children}</>;
};
export default LoaderWrapper;
